import initiator from './initiator'

export default {
    initiator,
    topic: {
        sourceAndInitiator: 'Source and initiator',
        titleAndDescription: 'Title and description',
        comment: {
            title: 'Comment',
            description: 'What makes this Company micro-trend special'
        },
        links: 'Links'
    },
    hint: {
        noData: 'No data found'
    },
    label: {
        initiators: 'Initiators',
        link: 'Link to source',
        country: 'Country/Countries',
        image: 'Cover picture',
        title: 'Title',
        description: 'Description',
        macrotrends: 'Macro-trends',
        innovationTypes: 'Innovation-type',
        industries: 'Industries'
    },
    subLabel: {
        innovationTypes: 'Select an innovation type.',
        industries: 'Select one or more industries.'
    },
    error: {
        titleAndDescription: 'Please enter a title and a description',
        url: 'Please enter a valid URL'
    },
    action: {
        submit: 'Submit',
        reset: 'Cancel'
    }
}
